import type { ReactNode } from 'react';

export enum HEADER_CHECKOUT_CONST {
  TEST_ID = 'header-checkout',
}

export type HeaderCheckoutProps = {
  children: ReactNode;
};
